import { ConfigurePrinterPage } from '@justomx/atlas-components'
import { useScanPrinter } from './ScanPrinter.hook'

const ScanPrinterPage = () => {
  const { actions } = useScanPrinter()

  return (
    <ConfigurePrinterPage
      title="Conectar impresora"
      onAction={actions.onGoBack}
      onPrinterPageChange={actions.onPrinterPageChange}
    />
  )
}

export default ScanPrinterPage
